<template>
	<div id="platform">
		<div :class="scrollFlag?'topLan1':'topLan'">
			<img  @click="jumpToIndex" class="CoBrand" src="../../static/pic/logo_hudie0@2x.png" />
			<div class="lan">
				<router-link :class="scrollFlag?'box1':'box'" :to="{path: 'index'}">首页</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'platform'}">电商平台
					<div :class="scrollFlag?'boxLine1':'boxLine'"></div>
				</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'canvass'}">招商入驻</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'about'}">关于我们</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'newsCenter'}">新闻中心</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'recruit'}">人才招聘</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'downLoad'}">下载APP</router-link>
				<!-- <a href="index" :class="scrollFlag?'box1':'box'">首页</a>
				<a href="platform" :class="scrollFlag?'box1':'box'">电商平台
					<div :class="scrollFlag?'boxLine1':'boxLine'"></div>
				</a>
				<a href="canvass" :class="scrollFlag?'box1':'box'">招商入驻</a>
				<a href="about" :class="scrollFlag?'box1':'box'">关于我们</a>
				<a href="newsCenter" :class="scrollFlag?'box1':'box'">新闻中心</a>
				<a href="recruit" :class="scrollFlag?'box1':'box'">人才招聘</a>
				<a href="downLoad" :class="scrollFlag?'box1':'box'">下载APP</a> -->
			</div>
		</div>


		<div id="id1" style="width: 100%;">
			<img style="width: 100%;" mode="widthFix" src="../../static/pic/img_web02_banner1.jpg" />
		</div>


		<div id="id2" style="width: 100%;height: auto;background-color: #F8F8F8;display: flex;flex-direction: column;">
			<div class="section2-titleLan">
				<div class="section2-title">专业的工程机械零配件在线商城</div>
				<div class="section2-line"></div>
			</div>
			<div class="id2-section2-bigArea">
				<div class="id2-section2-smallArea" v-if="reLoad">
					<div @click="showSection2Zhezhao(index)" class="id2-section2-box" v-for="(item,index) in lingpeijian"
						:key="index">
						<img :class="section2zhao?'id2-section2-boxPic-mohu':'id2-section2-boxPic'"
							class="id2-section2-boxPic" :src="item.coverPic" />
						<div class="id2-section2-boxTitle">{{item.title}}</div>
						<div class="id2-section2-priceLan">
							<div class="id2-section2-price">
								<div class="tag">￥</div>
								<div class="price">{{item.sellPrice}}</div>
							</div>
							<div class="id2-section2-priceCut">￥{{item.originalPrice}}</div>
						</div>
						<div class="section2hide" v-show="item.showzhao">
							<div class="section2hideInside">
								<img class="section2hideInsidePic" src="../../static/downLoadPic/customer.png" />
								<div class="section2hideInsidetxt">微信扫我购买</div>
							</div>
						</div>
					</div>
					<div class="id2-section2-box">
						<div class="id2-section2-lastBoxTitle1">更多商品优惠</div>
						<img class="id2-section2-lastBoxPic" src="../../static/downLoadPic/customer.png" />
						<div class="id2-section2-lastBoxTitle2">尽在创世蜜蜂APP</div>
					</div>
				</div>
			</div>
		</div>


		<div class="chooseLan">
			<div class="tabLan">
				<div @click="chooseTab(4)" :class="showZulin?'tabBox':'tabBoxUnselect'">设备租赁</div>
				<div @click="chooseTab(0)" :class="showWuliu?'tabBox':'tabBoxUnselect'">大件物流</div>
				<div @click="chooseTab(1)" :class="showSecond?'tabBox':'tabBoxUnselect'">二手交易</div>
				<div @click="chooseTab(2)" :class="showHire?'tabBox':'tabBoxUnselect'">机手招聘</div>
				<div @click="chooseTab(3)" :class="showWant?'tabBox':'tabBoxUnselect'">机手求职</div>
			</div>
		</div>


		<div id="id3" style="width: 100%;background-color: #F8F8F8;">
			<div class="section3-bigArea">


				<!-- 物流 -->
				<div class="section3-smallArea" v-if="showWuliu">
					<div @click="showSection3Zhezhao(index)" class="section3-wuliuBox" v-for="(item,index) in wuliu"
						:key="index">
						<div class="wuliuBox-startArea">{{item.departure}}</div>
						<div
							style="font-size: 16px;font-family: Microsoft YaHei;font-weight: bold;color: #2289FF;margin-top: 16px;text-align: left;">
							至</div>
						<div class="wuliuBox-endArea">{{item.destination}}</div>
						<div class="wuliuBox-item">{{item.title}}</div>
						<div class="wuliuBox-lan">
							<div class="wuliuBox-name">{{item.typeName}}|{{item.contactPerson}}</div>
							<div class="wuliuBox-time">{{item.createTime}}</div>
						</div>
						<div class="section3-wuliuHide" v-if="item.showzhao">
							<div class="section3hideInside">
								<img class="section3hideInsidePic" src="../../static/downLoadPic/customer.png" />
								<div class="section3hideInsidetxt">微信扫我购买</div>
							</div>
						</div>
					</div>
					<div class="section3-wuliuBox">
						<div class="section3-lastWuliuBoxTitle">更多物流需求</div>
						<img class="section3-lastWuliuBoxPic" src="../../static/downLoadPic/customer.png" />
						<div class="section3-lastWuliuBoxtxt">尽在创世蜜蜂APP</div>
					</div>
				</div>




				<!-- 招聘 -->
				<div class="section3-smallArea" v-if="showHire">
					<div class="section3-hireBox" @click="showSection3HireZhezhao(index)" v-for="(item,index) in zhaopin"
						:key="index">
						<div class="hireBox-startArea">{{item.workPlace}}</div>
						<!-- <div class="hireBox-endArea">河北省张家口市下花园区</div> -->
						<div v-if="item.faceToFace==0"
							style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #EF3845;margin-top: 26px;text-align: left;margin-left: 14px;">
							面议</div>
						<div v-else
							style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #EF3845;margin-top: 26px;text-align: left;margin-left: 14px;">
							{{item.salaryMin}}-{{item.salaryMax}}</div>
						<div class="hireBox-lan">
							<div class="hireBox-name">{{item.workExperienceStr}}|{{item.education}}</div>
							<div class="hireBox-time">{{item.createTime}}</div>
						</div>
						<div class="section3-HireHide" v-if="item.showzhao">
							<div class="section3HirehideInside">
								<img class="section3HirehideInsidePic" src="../../static/downLoadPic/customer.png" />
								<div class="section3HirehideInsidetxt">微信扫我查看详情</div>
							</div>
						</div>
					</div>
					<div class="section3-hireBox">
						<div class="section3-lastHireBoxTitle">更多商品优惠</div>
						<img class="section3-lastHireBoxPic" src="../../static/downLoadPic/customer.png" />
						<div class="section3-lastHireBoxtxt">尽在创世蜜蜂APP</div>
					</div>
				</div>



				<!-- 交易 -->
				<div class="section3-smallArea1" v-if="showSecond">
					<div class="section3-SecondBox" @click="showSection3SecondZhezhao(index)"
						v-for="(item,index) in ershou" :key="index">
						<img class="section3-SecondBoxPic" :src="item.pictures" />
						<div class="section3-SecondeBoxTitle">{{item.title}}</div>
						<div class="section3-SecondeBoxDetail">{{item.produceTime}}年/{{item.displayTime}}小时/{{item.province}}-{{item.district}}</div>
						<div class="section3-SecondeBoxLan">
							<div class="SecondBoxTag">￥</div>
							<div class="secondBoxPrice">面议</div>
							<div class="secondBoxBtn">询价</div>
						</div>
						<div class="section3-SecondBoxHide" v-if="item.showzhao">
							<div class="section3-SecondBoxHideInside">
								<img class="section3-SecondBoxHideInsidePic"
									src="../../static/downLoadPic/customer.png" />
								<div class="section3-SecondBoxHideInsidetxt">微信扫我购买</div>
							</div>
						</div>

					</div>
					<div class="section3-SecondBox">
						<div class="section3-lastSecondBoxTitle">更多整机优惠</div>
						<img class="section3-lastSecondBoxPic" src="../../static/downLoadPic/customer.png" />
						<div class="section3-lastSecondBoxtxt">尽在创世蜜蜂APP</div>
					</div>
				</div>



				<!-- 求职 -->
				<div class="section3-smallArea2" v-if="showWant">
					<div @click="showSection3WantZhezhao(index)" class="section3-wantBox" v-for="(item,index) in qiuzhi"
						:key="index">
						<img class="section3-wantBoxPic" src="http://image.hudiejx.com/jobWanted/20210608/4b609023c950498b8def7c268d33a77d.jpeg" />
						<div class="section3-wantBoxName">{{item.contactPerson}}</div>
						<div class="section3-wantBoxJob">{{item.title}}</div>
						<div class="section3-wantBoxSalery">{{item.salaryMin}}-{{item.salaryMax}}</div>
						<div class="section3-wantBoxAddress">{{item.workPlace}} | {{item.workExperienceStr}}</div>
						<div class="section3-wantBoxTime">{{item.createTime}}</div>
						<div class="section3-wantBoxHide" v-if="item.showzhao">
							<div class="section3-wantBoxHideInside">
								<img class="section3-wantBoxHideInsidePic"
									src="../../static/downLoadPic/customer.png" />
								<div class="section3-wantBoxHideInsidetxt">微信扫我购买</div>
							</div>
						</div>
					</div>
					<div class="section3-wantBox">
						<div class="section3-lastWantBoxTitle">更多商品优惠</div>
						<img class="section3-lastWantBoxPic" src="../../static/downLoadPic/customer.png" />
						<div class="section3-lastWantBoxtxt">尽在创世蜜蜂APP</div>
					</div>
				</div>
				
				<!-- 租赁 -->
				<div class="section3-smallArea2" style="height: auto;" v-if="showZulin">
					<div @click="showSection3Zulin(index)" class="section3-zulinBox" v-for="(item,index) in zulin"
						:key="index">
						
						<!-- <img class="section3-wantBoxPic" :src="item.pictures" />
						<div class="section3-wantBoxName">{{item.contactPerson}}</div>
						<div class="section3-wantBoxJob">{{item.title}}</div>
						<div class="section3-wantBoxSalery">{{item.salaryMin}}-{{item.salaryMax}}</div>
						<div class="section3-wantBoxAddress">{{item.workPlace}} | {{item.workExperienceStr}}</div>
						<div class="section3-wantBoxTime">{{item.createTime}}</div>
						<div class="section3-wantBoxHide" v-if="item.showzhao">
							<div class="section3-wantBoxHideInside">
								<img class="section3-wantBoxHideInsidePic"
									src="../../static/downLoadPic/customer.png" />
								<div class="section3-wantBoxHideInsidetxt">微信扫我购买</div>
							</div>
						</div> -->
						<img  class="section3-zulinPic" :src="item.pictures"/>
						<div class="section3-zulinBoxName">{{item.title}}</div>
						<div class="section3-zulinInfo">{{item.displayTime}}/{{item.province}}-{{item.city}}</div>
						<!-- <div class="section3-zulinDistance">{{item.distance}}</div> -->
						<div class="section3-zulinPrice">{{item.price}}万/月</div>
						<div class="section3-zulinBoxHide"  v-if="item.showzhao">
							<div class="section3-zulinBoxHideInside">
								<img class="section3-zulinBoxHideInsidePic" src="../../static/downLoadPic/customer.png"/>
								<div class="section3-zulinBoxHideInsidetxt">微信扫我租车</div>
							</div>
						</div>
						
					</div>
					<div class="section3-zulinBox">
						<div class="section3-lastWantBoxTitle">更多商品优惠</div>
						<img class="section3-lastWantBoxPic" src="../../static/downLoadPic/customer.png" />
						<div class="section3-lastWantBoxtxt" style="margin-bottom: 77px;">尽在创世蜜蜂APP</div>
					</div>
				</div>



			</div>
		</div>
		<bottom-area></bottom-area>
	</div>
</template>

<script>
	var lingpei = require('../../utils/lingpeijian.js')
	var wul = require('../../utils/wuliu.js')
	var zhaop = require('../../utils/zhaopin.js')
	var ers = require('../../utils/ershou.js')
	var qiuz = require('../../utils/qiuzhi.js')
	var zul = require('../../utils/zulin.js')
	import bottomArea from "../components/bottomArea.vue"
	export default {
		components: {
			bottomArea
		},
		data() {
			return {
				zulin:zul.zulinList,
				lingpeijian: lingpei.lingpeijian,
				wuliu : wul.wuliu,
				zhaopin : zhaop.zhaopin,
				ershou:ers.ershou,
				qiuzhi:qiuz.qiuzhi,
				windowHeight: String(document.documentElement.clientHeight),
				scrollFlag: false,
				xunhuan: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
				xunhuan1: [0, 1, 2, 3, 4, 5, 6],
				showWuliu: false,
				showSecond: false,
				showHire: false,
				showWant: false,
				showZulin: true,
				section2zhao: false,
				section3zhao: false,
				section3Secondzhao: false,
				section3Hirezhao: false,
				section3Wantzhao: false,
				reLoad:true
			}
		},
		created() {
			document.documentElement.scrollTop = 0
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
		},
		methods: {
			handleScroll() {
				let _this = this;
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				// console.log(scrollTop)
				if (scrollTop) {
					_this.scrollFlag = true
				} else {
					_this.scrollFlag = false
				}
			},
			chooseTab(type) {
				if (type == 0) {
					this.showWuliu = true
					this.showSecond = false
					this.showHire = false
					this.showWant = false
					this.showZulin = false
				} else if (type == 1) {
					this.showWuliu = false
					this.showSecond = true
					this.showHire = false
					this.showWant = false
					this.showZulin = false
				} else if (type == 2) {
					this.showWuliu = false
					this.showSecond = false
					this.showHire = true
					this.showWant = false
					this.showZulin = false
				} else if (type == 3) {
					this.showWuliu = false
					this.showSecond = false
					this.showHire = false
					this.showWant = true
					this.showZulin = false
				} else {					
					this.showWuliu = false
					this.showSecond = false
					this.showHire = false
					this.showWant = false
					this.showZulin = true
				}
			},
			showSection2Zhezhao(index) {
				console.log(index)
				for(var i = 0;i<this.lingpeijian.length;i++){
					this.lingpeijian[i].showzhao= false
				}
				this.lingpeijian[index].showzhao = !this.lingpeijian[index].showzhao
				console.log(this.lingpeijian[index].showzhao)
				this.reLoad = false
				this.reLoad = true
				// this.section2zhao = !this.section2zhao
			},
			showSection3Zhezhao(index) {
				for(var i = 0;i<this.wuliu.length;i++){
					this.wuliu[i].showzhao= false
				}
				this.wuliu[index].showzhao = !this.wuliu[index].showzhao
				this.showWuliu = false
				this.showWuliu = true
				// this.section3zhao = !this.section3zhao
			},
			showSection3SecondZhezhao(index) {
				for(var i = 0;i<this.ershou.length;i++){
					this.ershou[i].showzhao= false
				}
				this.ershou[index].showzhao = !this.ershou[index].showzhao
				this.showSecond = false
				this.showSecond = true
				// this.section3Secondzhao = !this.section3Secondzhao
			},
			showSection3HireZhezhao(index) {
				for(var i = 0;i<this.zhaopin.length;i++){
					this.zhaopin[i].showzhao= false
				}
				this.zhaopin[index].showzhao = !this.zhaopin[index].showzhao
				this.showHire = false
				this.showHire = true
				// this.section3Hirezhao = !this.section3Hirezhao
			},
			showSection3WantZhezhao(index) {
				for(var i = 0;i<this.qiuzhi.length;i++){
					this.qiuzhi[i].showzhao= false
				}
				this.qiuzhi[index].showzhao = !this.qiuzhi[index].showzhao
				this.showWant = false
				this.showWant = true
				// this.section3Wantzhao = !this.section3Wantzhao
			},
			showSection3Zulin(index) {
				for(var i = 0;i<this.zulin.length;i++){
					this.zulin[i].showzhao= false
				}
				this.zulin[index].showzhao = !this.zulin[index].showzhao
				this.showZulin = false
				this.showZulin = true
				// this.section3Wantzhao = !this.section3Wantzhao
			},
			jumpToIndex(){
				this.$router.push({
					name: 'index',
					params: {}
				});
			}
		}
	}
</script>

<style scoped>
	html,
	body,
	#platform {
		width: 100%;
		height: 100%;
	}

	.section2-titleLan {
		width: 100%;
		height: 108px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.section2-title {
		margin-top: 53px;
		font-size: 26px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #333333;
	}

	.section2-line {
		width: 28px;
		height: 2px;
		background: #467CFD;
		margin-top: 16px;
	}

	.id2-section2-bigArea {
		width: 100%;
		margin-top: 47px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.id2-section2-smallArea {
		width: 1250px;
	}

	.id2-section2-box {
		margin-right: 30px;
		margin-bottom: 30px;
		float: left;
		width: 280px;
		height: 400px;
		background: #FFFFFF;
		display: flex;
		flex-direction: column;
		position: relative;
		cursor: pointer;
	}

	.id2-section2-boxPic {
		width: 220px;
		height: 220px;
		margin-top: 28px;
		margin-left: 30px;
	}

	.id2-section2-boxPic-mohu {
		width: 220px;
		height: 220px;
		margin-top: 28px;
		margin-left: 30px;
		-webkit-filter: blur(3px);
		filter: blur(3px);
	}

	.id2-section2-boxTitle {
		/* height: 63px; */
		width: 250px;
		padding-left: 15px;
		padding-right: 15px;
		padding-top: 33px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #686868;
		text-align: left;
		display: -webkit-box;
		/* -webkit-box-orient: vertical; */
		/*! autoprefixer: off */
		-webkit-box-orient: vertical;
		/* autoprefixer: on */
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.id2-section2-priceLan {
		position: absolute;
		width: 250px;
		padding: 25px 15px 0 15px;
		bottom: 20px;
	}

	.id2-section2-price {
		float: left;
		display: flex;
	}

	.tag {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #111111;
		line-height: 34px;
	}

	.price {
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #111111;
	}

	.id2-section2-priceCut {
		float: right;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		text-decoration: line-through;
		color: #CBCBCB;
		line-height: 34px;
	}

	.id2-section2-lastBoxTitle1 {
		width: 100%;
		text-align: center;
		margin-top: 65px;
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}

	.id2-section2-lastBoxPic {
		width: 156px;
		height: 156px;
		margin-top: 38px;
		margin-left: 62px;
	}

	.id2-section2-lastBoxTitle2 {
		margin-top: 38px;
		width: 100%;
		text-align: center;
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}

	.section2hide {
		position: absolute;
		width: 220px;
		height: 220px;
		top: 30px;
		left: 28px;
		background: rgba(0, 0, 0, 0.3);
	}

	.section2hideInside {
		width: 100%;
		height: 100%;
		position: relative;
	}

	/* .section2hideInsidePic{
		width: 100%;
		height: 100%;
		position: relative;
	} */
	.section2hideInsidePic {
		position: absolute;
		width: 160px;
		height: 160px;
		top: 20px;
		left: 32px;
	}

	.section2hideInsidetxt {
		position: absolute;
		width: 100%;
		text-align: center;
		bottom: 13px;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
	}

	.chooseLan {
		width: 100%;
		height: 44px;
		background: #467CFD;
		display: flex;
		justify-content: center;
	}

	.tabLan {
		width: 1250px;
		display: flex;
		height: 44px;
		/* margin-left: 350px; */
	}

	.tabBox {
		width: 108px;
		height: 44px;
		background: #3E6FE5;
		line-height: 44px;
		text-align: center;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
		cursor: pointer;
	}

	.tabBoxUnselect {
		width: 108px;
		height: 44px;
		background: #467CFD;
		line-height: 44px;
		text-align: center;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
		cursor: pointer;
	}

	.section3-bigArea {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.section3-smallArea {
		margin-top: 32px;
		width: 1250px;
	}




	.section3-wuliuBox {
		margin-right: 30px;
		margin-bottom: 30px;
		float: left;
		width: 250px;
		height: 260px;
		background: #FFFFFF;
		display: flex;
		flex-direction: column;
		position: relative;
		cursor: pointer;
		padding: 0 15px
	}

	.wuliuBox-startArea {
		width: 250px;
		margin-top: 30px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #111111;
		text-align: left;
	}

	.wuliuBox-endArea {
		width: 250px;
		margin-top: 15px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #111111;
		text-align: left;
	}

	.wuliuBox-item {
		margin-top: 13px;
		width: 250px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #686868;
		text-align: left;
	}

	.wuliuBox-lan {
		width: 250px;
		position: absolute;
		bottom: 36px;
	}

	.wuliuBox-name {
		float: left;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #CBCBCB;
	}

	.wuliuBox-time {
		float: right;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #CBCBCB;
	}

	.section3-lastWuliuBoxTitle {
		margin-top: 20px;
		width: 250px;
		text-align: center;
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}

	.section3-lastWuliuBoxPic {
		width: 156px;
		height: 156px;
		margin-top: 13px;
		margin-left: 47px;
	}

	.section3-lastWuliuBoxtxt {
		margin-top: 10px;
		width: 250px;
		text-align: center;
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}

	.section3-wuliuHide {
		position: absolute;
		width: 280px;
		height: 261px;
		background: rgba(0, 0, 0, 0.3);
		top: 0;
		left: 0;
	}

	.section3hideInside {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.section3hideInsidePic {
		position: absolute;
		width: 160px;
		height: 160px;
		top: 40px;
		left: 62px;
	}

	.section3hideInsidetxt {
		position: absolute;
		width: 100%;
		text-align: center;
		bottom: 33px;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
	}

	.section3-smallArea1 {
		margin-top: 32px;
		width: 1250px;
		height: 1000px;
	}





	.section3-SecondBox {
		float: left;
		width: 280px;
		height: 450px;
		margin-right: 30px;
		margin-bottom: 30px;
		background: #FFFFFF;
		position: relative;
		cursor: pointer;
	}

	.section3-SecondBoxPic {
		width: 220px;
		height: 220px;
		margin-top: 28px;
	}

	.section3-SecondeBoxTitle {
		width: 250px;
		margin-left: 15px;
		margin-top: 33px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #111111;
		text-align: left;
	}

	.section3-SecondeBoxDetail {
		text-align: left;
		width: 250px;
		margin-left: 15px;
		margin-top: 25px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #686868;
	}

	.section3-SecondeBoxLan {
		position: absolute;
		width: 250px;
		height: 36px;
		display: block;
		bottom: 20px;
		/* margin-top: 35px; */
	}

	.SecondBoxTag {
		float: left;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FF6600;
		line-height: 46px;
		margin-left: 15px;
	}

	.secondBoxPrice {
		float: left;
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FF6600;
		line-height: 42px;
	}

	.secondBoxBtn {
		float: right;
		width: 80px;
		height: 36px;
		background: #FF6600;
		border-radius: 4px;
		text-align: center;
		line-height: 36px;
		font-size: 19px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #FFFFFF;
	}

	.section3-lastSecondBoxTitle {
		margin-top: 83px;
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}

	.section3-lastSecondBoxPic {
		margin-top: 38px;
		width: 156px;
		height: 156px;
	}

	.section3-lastSecondBoxtxt {
		margin-top: 38px;
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}

	.section3-SecondBoxHide {
		position: absolute;
		width: 220px;
		height: 220px;
		background: rgba(0, 0, 0, 0.3);
		top: 28px;
		left: 30px;
	}

	.section3-SecondBoxHideInside {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.section3-SecondBoxHideInsidePic {
		position: absolute;
		width: 160px;
		height: 160px;
		top: 19px;
		left: 32px;
	}

	.section3-SecondBoxHideInsidetxt {
		position: absolute;
		width: 100%;
		text-align: center;
		bottom: 13px;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
	}




	.section3-hireBox {
		width: 280px;
		height: 230px;
		background: #FFFFFF;
		margin-right: 30px;
		margin-bottom: 30px;
		float: left;
		display: flex;
		flex-direction: column;
		position: relative;
		cursor: pointer;
	}
	.hireBox-startArea {
		margin-top: 27px;
		margin-left: 15px;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #111111;
		text-align: left;
	}

	.hireBox-endArea {
		margin-top: 21px;
		text-align: left;
		margin-left: 15px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #686868;
	}

	.hireBox-lan {
		position: absolute;
		width: 280px;
		bottom: 30px;
	}

	.hireBox-name {
		float: left;
		margin-left: 15px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #CBCBCB;
	}

	.hireBox-time {
		float: right;
		margin-right: 15px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #CBCBCB;
	}

	.section3-lastHireBoxTitle {
		margin-top: 12px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}

	.section3-lastHireBoxPic {
		margin-left: 65px;
		margin-top: 6px;
		width: 156px;
		height: 156px;
	}

	.section3-lastHireBoxtxt {
		margin-top: 11px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}

	.section3-HireHide {
		position: absolute;
		width: 280px;
		height: 230px;
		background: rgba(0, 0, 0, 0.3);
		top: 0;
		left: 0;
	}

	.section3HirehideInside {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.section3HirehideInsidePic {
		position: absolute;
		width: 160px;
		height: 160px;
		top: 23px;
		left: 63px;
	}

	.section3HirehideInsidetxt {
		position: absolute;
		width: 100%;
		text-align: center;
		bottom: 19px;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
	}




	.section3-smallArea2 {
		margin-top: 32px;
		width: 1250px;
		height: 800px;
	}

	.section3-wantBox {
		position: relative;
		float: left;
		margin-right: 30px;
		margin-bottom: 30px;
		width: 250px;
		height: 353px;
		padding: 0px 15px;
		background: #FFFFFF;
		display: flex;
		/* justify-content: center; */
		flex-direction: column;
		align-items: center;
	}

	.section3-wantBoxPic {
		width: 102px;
		height: 102px;
		margin-top: 29px;
	}

	.section3-wantBoxName {
		margin-top: 15px;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #111111;
	}

	.section3-wantBoxJob {
		margin-top: 12px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #686868;
	}

	.section3-wantBoxSalery {
		margin-top: 15px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #EF3845;
	}

	.section3-wantBoxAddress {
		margin-top: 30px;
		width: 250px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #CBCBCB;
	}

	.section3-wantBoxTime {
		position: absolute;
		bottom: 20px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #CBCBCB;
	}

	.section3-lastWantBoxTitle {
		margin-top: 38px;
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}

	.section3-lastWantBoxPic {
		margin-top: 38px;
		width: 156px;
		height: 156px;
	}

	.section3-lastWantBoxtxt {
		margin-top: 38px;
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}

	.section3-wantBoxHide {
		position: absolute;
		width: 220px;
		height: 220px;
		background: rgba(0, 0, 0, 0.3);
		top: 21px;
		left: 28px;
	}

	.section3-wantBoxHideInside {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.section3-wantBoxHideInsidePic {
		position: absolute;
		width: 160px;
		height: 160px;
		top: 19px;
		left: 32px;
	}

	.section3-wantBoxHideInsidetxt {
		position: absolute;
		width: 100%;
		text-align: center;
		bottom: 13px;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
	}
	
	.section3-zulinBox{
		width: 280px;
		display: flex;
		flex-direction: column;
		margin-right: 30px;
		margin-bottom: 30px;
		background-color: #FFFFFF;
		position: relative;
		cursor: pointer;
		align-items: center;
		float: left;
	}
	.section3-zulinPic{
		width: 220px;
		height: 220px;
		margin-left: 32rpx;
		margin-top: 28px;
	}
	.section3-zulinBoxName{
		width: calc(100% - 17px);
		text-overflow: ellipsis;
		overflow: hidden;
		white-space:nowrap;
		padding-top: 20px;
		padding-left: 17px;
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #111111;
		text-align: left;
	}
	.section3-zulinInfo{
		width: calc(100% - 17px);
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #686868;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space:nowrap;
		padding-top: 22px;
		padding-left: 17px;
		text-align: left;
	}
	.section3-zulinPrice{
		width: calc(100% - 17px);
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FF0030;
		padding-top: 22px;
		padding-left: 17px;
		text-align: left;
		margin-bottom: 20px;
	}
	.section3-zulinBoxHide{
		position: absolute;
		width: 220px;
		height: 220px;
		background: rgba(0, 0, 0, 0.3);
		top: 28px;
		left: 32px;
	}
	.section3-zulinBoxHideInside{
		width: 100%;
		height: 100%;
		position: relative;
	}
	.section3-zulinBoxHideInsidePic{
		position: absolute;
		width: 160px;
		height: 160px;
		top: 28px;
		left: 32px;
	}
	.section3-zulinBoxHideInsidetxt{
		position: absolute;
		width: 100%;
		text-align: center;
		bottom: 10px;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
	}
</style>
